import { render, staticRenderFns } from "./ListRewardAffiliate.vue?vue&type=template&id=20bc6cab&scoped=true"
import script from "./ListRewardAffiliate.vue?vue&type=script&lang=js"
export * from "./ListRewardAffiliate.vue?vue&type=script&lang=js"
import style0 from "./ListRewardAffiliate.vue?vue&type=style&index=0&id=20bc6cab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bc6cab",
  null
  
)

export default component.exports